import { render, staticRenderFns } from "./ChatAdminSelector.vue?vue&type=template&id=bdb0ee6c&"
import script from "./ChatAdminSelector.vue?vue&type=script&lang=js&"
export * from "./ChatAdminSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports